export default __webpack_public_path__ + "static/optional_steps_rooftop_solar-7291c3a26b88a6ffd1b5e16a9df4f4b4.png";